module.exports = __webpack_public_path__ + "img/img-f77cd3.png";